import { Box, Typography } from "@mui/material";
import { CircularProgress, Grid } from "@mui/material"
import { useState, useEffect } from "react";
import HashTagService from "../../services/hashTag.service";
import CardSearchNav from "../card/CardSearchNav";
import SinResultados from "./SinResultados";
import SearchLoading from "./SearchLoading";

const TabTags = ({textSearch,handleClose}) => {
    const [options, setOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const handleSearchTags = async() => {
        if(textSearch?.length >= 2){
            setIsLoading(true);
            await HashTagService.getAll({searchText: textSearch,type:'search'}).then((data)=>{
                setOptions(
                    data.map((item) =>{
                        return {
                            ...item,
                            tituloCard: `Ticket #${item?.nroTk}`,
                            descripCard: `${item?.comentario ? 'Comentario:' : 'Cuerpo:'} ${item?.cuerpo?.replace(/<[^>]*>?/gm, '')}`,
                            empresaCard: 'NUBICOM',
                            keyCard: `${item?.nroTk}${item?.comentario || 'tk'}`
                        }
                    })
                )
            })
            .finally(() => {
                setIsLoading(false);
            });
        }
    };
    useEffect(() => {
        const delayWrite = setTimeout(() => {
            handleSearchTags()
        }, 500)
        return () => clearTimeout(delayWrite)
    }, [textSearch])
    return (
        <Grid container>
            { !isLoading ? (
                <>
                    {options && options?.length > 0 ? (
                        options?.map((option)=>(
                            <Grid item xs={12} key={`${option?.keyCard}c`}>
                                <CardSearchNav
                                    item={option}
                                    descripcion={option?.descripCard}
                                    titulo={option?.tituloCard}
                                    key={option?.keyCard}
                                    onCLoseModal={handleClose}
                                    textSearch={textSearch}
                                />
                            </Grid>
                        ))
                    ):(
                        <Grid item xs={12} key='sinTag'>
                            <SinResultados />
                        </Grid>
                    )}
                </>
            ):(
                <Grid item xs={12} key='circletatag'>
                    <SearchLoading />
                </Grid>
            )}
        </Grid>
    )
}

export default TabTags